// extracted by mini-css-extract-plugin
export default {"wrapper":"StrategyTemplateEdit_wrapper__fu2aK","add-row-btn":"StrategyTemplateEdit_add-row-btn__Dbs7s","row-btn-inner":"StrategyTemplateEdit_row-btn-inner__iVm2x"};